import React from 'react';
import './ByPolko.css';

const ByPolko = (props) => {

    const fontSizePOLKO = props.fontSize;
    const fontSizeBY = fontSizePOLKO*0.4;

    const stylePOLKO = {
        fontSize : fontSizePOLKO,
        marginLeft : "5px",
    }

    const styleBY = {
        fontSize : fontSizeBY,
        transform: "rotate(-90deg)",
    }


    return (
        <div>
            <p
              className="font-face-poppins-bold"
              style={{
                transform: "rotate(-90deg)",
                fontSize: "10px",
              }}
            >
              by<span style={stylePOLKO}>POLKO</span>
            </p>
        </div>
    )
}

export default ByPolko;